<p-card class="h-full">
  <!-- Header Template -->
  <ng-template pTemplate="header">
    @if (item.coverImage) {
      <img 
        [src]="item.coverImage" 
        [alt]="item.title"
        class="w-full h-48 object-cover"
      />
    } @else {
      <div class="h-48 bg-gradient-to-br from-green-500 to-blue-600 flex items-center justify-center">
        <i class="pi pi-book text-white text-4xl"></i>
      </div>
    }
  </ng-template>

  <!-- Content Template -->
  <ng-template pTemplate="content">
    <!-- Title -->
    <h3 class="text-heading-md mb-2 line-clamp-2">
      {{ item.title }}
    </h3>

    <!-- Description -->
    <p class="text-body-sm text-secondary mb-4 line-clamp-3">
      {{ item.description }}
    </p>

    <!-- Link URL -->
    <div class="mb-4">
      <a 
        [href]="item.linkUrl" 
        target="_blank" 
        rel="noopener noreferrer"
        class="text-primary text-caption-lg font-medium inline-flex items-center gap-1">
        {{ 'learnMore.viewItem' | translate }}
        <i class="pi pi-external-link text-xs"></i>
      </a>
    </div>
  </ng-template>

  <!-- Footer Template -->
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        icon="pi pi-pencil"
        size="small"
        [rounded]="true"
        (onClick)="onEdit()"
        [ariaLabel]="'learnMore.editItem' | translate">
      </p-button>

      <p-button
        icon="pi pi-trash"
        size="small"
        [rounded]="true"
        severity="danger"
        (onClick)="onRemove()"
        [ariaLabel]="'learnMore.removeItem' | translate">
      </p-button>
    </div>
  </ng-template>
</p-card>